import { render, staticRenderFns } from "./CommissionAccount.vue?vue&type=template&id=27457af8&scoped=true"
import script from "./CommissionAccount.vue?vue&type=script&lang=js"
export * from "./CommissionAccount.vue?vue&type=script&lang=js"
import style0 from "./CommissionAccount.vue?vue&type=style&index=0&id=27457af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27457af8",
  null
  
)

export default component.exports